// extracted by mini-css-extract-plugin
export default {"text":"AcceptStatements_text__uXyy7"};